module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-img', {
    staticClass: "black--text",
    attrs: {
      "height": "200px",
      "src": _vm.mapUrl(_vm.location)
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-end": "",
      "flexbox": ""
    }
  }, [_c('span', {
    staticClass: "headline elevation-10 pa-2 white"
  }, [_vm._v(_vm._s(_vm.location.name))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-title', [_vm._v(_vm._s(_vm.location.address))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("edit")
      }
    }
  }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" Edit address")], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-251d103d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/LocationView.vue
// module id = 1361
// module chunks = 9